export default "__VITE_ASSET__02daa5a6__"